<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M7.67421 11.8499L15.5242 3.99992L16.2342 4.70992L9.08421 11.8599L16.2342 18.9999L15.5242 19.7099L7.67421 11.8599L7.67421 11.8499Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5242 20.0635L7.42422 11.9635L7.42422 11.7464L15.5242 3.64637L16.5878 4.70992L9.43789 11.8598L16.5879 18.9998L15.5242 20.0635ZM15.8805 19L8.73054 11.86L15.8807 4.70992L15.5242 4.35348L8.02277 11.8549L15.5242 19.3564L15.8805 19Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
